import { NavLink } from 'react-router-dom';
import {
  Checkbox,
  IconAnimatedDots,
  IconArrowRight,
  IconSearch,
  InputSize,
  InputText,
  PaymentType,
  PermissionEnum,
  Select,
} from '@ui/src';
import { useAppSelector } from '@store';
import { CustomerStatus } from '../../../hoc/customers/types';
import { ExternalAccountTypes } from './types';

import cn from './styles.module.css';

const ExternalAccount = ({
  externalAccount,
  status,
  setStatus,
  availablePaymentTypes,
  searchValue,
  onSearch,
  currencies,
  activePermissions,
  organizationStatus,
  casp,
  balancesIsLoading,
  selectedCurrencies,
  setSelectedCurrencies,
  isOpenPayd,
  isKeel,
}: ExternalAccountTypes) => {
  const { currencies: dictionariesCurrencies } = useAppSelector(
    (state) => state.root,
  );

  return (
    <>
      <Select
        name="status"
        value={status}
        title="Status"
        list={[
          {
            name: 'Enabled',
            value: 'enabled',
          },
          {
            name: 'Disabled',
            value: 'disabled',
          },
        ]}
        onChange={(e) => setStatus(e.target.value as string)}
        selectWrapperClassName={cn.statusWrapper}
        disabled={
          !activePermissions?.includes(
            PermissionEnum.PSP_INTEGRATION_ACCOUNT_EDIT_ACTION,
          ) || organizationStatus === CustomerStatus.CLOSED
        }
        fullWidth
      />

      {externalAccount?.pspIntegrationPayment?.paymentsTypes?.includes(
        PaymentType.CRYPTO_ASSET_PAYMENT,
      ) && (
        <Select
          name="caspId"
          value={externalAccount?.caspId}
          title="CASP"
          list={casp?.map((item) => ({ name: item.name, value: item.id }))}
          selectWrapperClassName={cn.statusWrapper}
          placeholder="Select CASP"
          fullWidth
          disabled
        />
      )}
      <div className={cn.infoBlock}>
        <div className={cn.infoBlockRow}>
          <div className={cn.infoBlockRowTitle}>IBAN</div>
          <div className={cn.infoBlockRowValue}>{externalAccount?.iban}</div>
        </div>
        <div className={cn.infoBlockRow}>
          <div className={cn.infoBlockRowTitle}>Bank</div>
          <div className={cn.infoBlockRowValue}>
            <NavLink
              to={`/bank-and-psp/${externalAccount?.pspPartner?.id}`}
              target="_blank"
              className={cn.infoBlockRowLink}
            >
              {externalAccount?.pspPartner?.companyName}
              <IconArrowRight width={12} height={12} />
            </NavLink>
          </div>
        </div>
        <div className={cn.infoBlockRow}>
          <div className={cn.infoBlockRowTitle}>Payment type</div>
          <div className={cn.infoBlockRowValue}>
            {availablePaymentTypes?.join(', ')}
          </div>
        </div>

        <div className={cn.infoBlockRow}>
          <div className={cn.infoBlockRowTitle}>Customer Account</div>
          <div className={cn.infoBlockRowValue}>
            <NavLink
              to={`/accounts/list/${externalAccount?.accountId}`}
              target="_blank"
              className={cn.infoBlockRowLink}
            >
              {externalAccount?.account?.fullNumber}
              <IconArrowRight width={12} height={12} />
            </NavLink>
          </div>
        </div>
      </div>

      <div className={cn.currenciesTitle}>Available Currencies</div>
      {balancesIsLoading && (
        <div className={cn.balancesLoader}>
          Loading <IconAnimatedDots width={26} height={26} />
        </div>
      )}
      {!balancesIsLoading && (
        <div className={cn.searchInputWrapper}>
          <IconSearch />
          <InputText
            name="searchValue"
            placeholder="Enter currency"
            className={cn.searchInput}
            value={searchValue}
            onChange={(e) => onSearch(e.target.value)}
            size={InputSize.SMALL}
          />
        </div>
      )}

      {!balancesIsLoading && (
        <>
          {dictionariesCurrencies
            ?.filter((item) => selectedCurrencies?.includes(item.id))
            ?.map((item) => (
              <div className={cn.checkboxWrapper} key={item.id}>
                <Checkbox
                  name={`currency-${item.id}`}
                  type="checkbox"
                  checked={Boolean(
                    selectedCurrencies?.find(
                      (currency) => currency === item.id,
                    ),
                  )}
                  title={item.name}
                  onChange={(e) => {
                    let nextCurrencies = ([] as string[]).concat(
                      selectedCurrencies,
                    );

                    if (e.target.checked) {
                      nextCurrencies.push(item.id);
                    } else {
                      nextCurrencies = nextCurrencies?.filter(
                        (currency) => currency !== item.id,
                      );
                    }

                    setSelectedCurrencies(nextCurrencies);
                  }}
                  disabled={isOpenPayd || isKeel}
                />
              </div>
            ))}
          {currencies
            ?.filter((item) => !selectedCurrencies.includes(item.id))
            ?.map((item) => (
              <div className={cn.currencyItem} key={item.id}>
                <Checkbox
                  name={`currency-${item.id}`}
                  type="checkbox"
                  title={item.name}
                  checked={Boolean(
                    selectedCurrencies?.find(
                      (currency) => currency === item.id,
                    ),
                  )}
                  onChange={() => {
                    let nextCurrencies = ([] as string[]).concat(
                      selectedCurrencies,
                    );

                    if (
                      nextCurrencies?.find((currency) => currency === item.id)
                    ) {
                      nextCurrencies = nextCurrencies.filter(
                        (currency) => currency !== item.id,
                      );
                    } else {
                      nextCurrencies.push(item.id);
                    }

                    setSelectedCurrencies(nextCurrencies);
                  }}
                  disabled={isOpenPayd || isKeel}
                />
              </div>
            ))}
        </>
      )}
    </>
  );
};

export default ExternalAccount;
